import dayjs from "dayjs";
import {EntityBase} from "../../shared/entity/EntityBase";

const BANNER_FIELDS = {
    id: { type: parseInt, defaultValue: 0 },
    name: { defaultValue: '' },
    onOff: { type: Number, defaultValue: 1 },
    isForcedExposure: { type: Number, defaultValue: 0 },
    priority: { type: Number, defaultValue: 0 },
    begin: { defaultValue: dayjs().startOf('day').unix() },
    end: { defaultValue: dayjs().endOf('day').unix() },
    action: { type: Number, defaultValue: 0 },
    banners: { defaultValue: [] },
    target: { type: Number, defaultValue: 1 },
    isTarget: { type: Number, defaultValue: 0 },
    targetVersionList: { type: Array, defaultValue: [] },
    minLevel: { type: Number, defaultValue: 0 },
    maxLevel: { type: Number, defaultValue: 0 }
}

export class BannerEntity extends EntityBase{
    constructor(data = {}) {
        super(data, BANNER_FIELDS);

        this.errors  = [
            { condition: () => this.begin > this.end, message: '시작일이 종료일보다 늦습니다.' },
            { condition: () => this.end < dayjs().unix(), message: '종료일이 현재 시간보다 이전입니다.' },
            { condition: () => this.banners.length === 0, message: '배너가 없습니다.' },
            { condition: () => this.target === 0 && !this.banners.some(banner => banner.countryCode === 'US'), message: '모든 타겟일 경우 US 국가가 포함되어야 합니다.' },
            { condition: () => this.isTarget === 1 && this.targetVersionList.filter(Boolean).length === 0, message: '버전을 선택하세요.' },
            { condition: () => this.isTarget === 1 && this.targetVersionList.length === 2 && (!this.targetVersionList[0] || !this.targetVersionList[1]), message: '버전 범위를 모두 선택하세요.' },
            { condition: () => this.isLevelRangeInvalid(), message: '최소 레벨이 최대 레벨보다 큽니다.' }
        ];
    }

    isLevelRangeInvalid() {
        return this.minLevel > 0 && this.maxLevel > 0 && this.minLevel > this.maxLevel;
    }
}